// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import {
  incrementFilter,
  resetFilter,
  setComponentsExhibition,
  setList,
  addFilter,
  setFilter,
  removeFilter,
  setFiltersList
} from '%/stores/Filters/UsedVehicles/FilterV3';
import {
  parseFiltersStoreStateToComponentState
} from '%/utils/filters/usedVehicles/parseFiltersStoreStateToComponentState';
import { clearURLFilters } from '%/utils/filters/usedVehicles/clearURLSearchParams';
import { mapFiltersV2 } from '%/utils/filters/usedVehicles/mapFiltersV2';
import KeywordField from '../SimpleFilter/KeywordField';
import BrandsAndModels from './BrandsAndModels';
import Pills from './Pills';
import PriceRange from './PriceRange';
import YearRange from './YearRange';
import KmRange from './KmRange';
import UnitsSelect from './UnitsSelect';
import FilterCheckbox from './FilterCheckbox';

class AdvancedFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showingModal: false,
      totalVehicles: null,
      filtersList: {
        brands: [],
        models: [],
        units: [],
        categories: [],
        transmissions: [],
        keyword: null,
        min_price: null,
        max_price: null,
      },
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.watchStore = this.watchStore.bind(this);
    this.updateStateFromStore = this.updateStateFromStore.bind(this);
  }

  componentDidMount() {
    this.watchStore()
  }

  handleCloseModal() {
    setComponentsExhibition({
      advancedFilter: false,
    });
  }

  handleClickOutside(event) {
    if (this.modalContentRef && !this.modalContentRef.contains(event.target)) {
      this.handleCloseModal();
    }
  }

  handleClearFilters() {
    setComponentsExhibition({
      advancedFilter: false,
    });
    resetFilter();
    setList();
    clearURLFilters()
  }

  handleSearchConfirm() {
    setComponentsExhibition({
      advancedFilter: false,
    });
  }

  updateFilterList(filterKey, filterValue) {
    const filter = {
      key: mapFiltersV2[filterKey],
      value: filterValue
    }

    incrementFilter(filter)
    setList();
  }

  updateStateFromStore(state) {
    const { filtersList } = state
    const parsedFiltersList = parseFiltersStoreStateToComponentState(filtersList)
    
    this.setState({
      filtersList: parsedFiltersList
    });
  }
  
  watchStore() {
    window.store.UsedVehiclesFilter.watch(incrementFilter, this.updateStateFromStore);
    window.store.UsedVehiclesFilter.watch(setFiltersList, this.updateStateFromStore);
    window.store.UsedVehiclesFilter.watch(addFilter, this.updateStateFromStore);
    window.store.UsedVehiclesFilter.watch(setFilter, this.updateStateFromStore);
    window.store.UsedVehiclesFilter.watch(removeFilter, this.updateStateFromStore);
    window.store.UsedVehiclesFilter.watch(resetFilter, this.updateStateFromStore);
    window.store.UsedVehiclesFilter.watch(state => {
      this.setState({
        totalVehicles: state.total,
      })
    });
    window.store.UsedVehiclesFilter.watch(setComponentsExhibition, state => {
      this.setState({
        showingModal: state.componentsExhibition.advancedFilter,
      })
    })
  }
  
  render() {
    const { showingModal, totalVehicles, filtersList } = this.state;

    return (
      <div
        className="filter-v2__advanced-filter advanced-filter"
        data-open={showingModal}
        onClick={this.handleClickOutside}
      >
        <div className="advanced-filter__overlay">
          <div
            className="advanced-filter__modal"
            ref={node => {
              this.modalContentRef = node;
            }}
          >
            <div className="advanced-filter__modal-content">
              <div className="advanced-filter__modal-header">
                <h4 className="advanced-filter__modal-header-title">Filtros</h4>
                
                <button
                  className="advanced-filter__modal-header-button-close button--close"
                  onClick={this.handleCloseModal}
                >
                  <i className="icon icon-close" />
                </button>
              </div>
              <div className="advanced-filter__modal-body">
                <Pills />
                <KeywordField
                  handleUpdateFilter={this.updateFilterList}
                  currentValue={filtersList.keyword}
                />
                <UnitsSelect
                  handleUpdateFilter={this.updateFilterList}
                  currentValue={filtersList.units}
                />
                <BrandsAndModels
                  activeBrands={filtersList.brands}
                  activeModels={filtersList.models}
                  handleUpdateFilter={this.updateFilterList}
                />
                <PriceRange
                  handleUpdateFilter={this.updateFilterList}
                  currentMinPrice={filtersList.min_price}
                  currentMaxPrice={filtersList.max_price}
                />
                <YearRange
                  handleUpdateFilter={this.updateFilterList}
                  currentMinYear={filtersList.min_model_year}
                  currentMaxYear={filtersList.max_model_year}
                />
                <KmRange
                  handleUpdateFilter={this.updateFilterList}
                  currentMinKm={filtersList.min_km}
                  currentMaxKm={filtersList.max_km}
                />
                <FilterCheckbox
                  handleUpdateFilter={this.updateFilterList}
                  activeItems={filtersList.categories}
                  filterName="categories"
                  title="Categoria"
                />
                <FilterCheckbox
                  handleUpdateFilter={this.updateFilterList}
                  activeItems={filtersList.transmissions}
                  filterName="transmissions"
                  title="Câmbio"
                />
                <FilterCheckbox
                  handleUpdateFilter={this.updateFilterList}
                  activeItems={filtersList.colors}
                  filterName="colors"
                  title="Cor"
                />
              </div>
            </div>
            <div className="advanced-filter__modal-footer">
              <button
                className="btn button button--outline button--clear-filters"
                onClick={this.handleClearFilters}
              >
                Limpar filtros
              </button>
              <button
                className="btn button button--primary"
                onClick={this.handleSearchConfirm}
              >
                Ver {totalVehicles} veículos
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AdvancedFilter.defaultProps = {};

AdvancedFilter.propTypes = {};

export default AdvancedFilter;
